import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

const Divider = ({ className, ...rest }) => (
  <hr
    className={twMerge('size-px border-none bg-neutral-high-500', className)}
    {...rest}
  />
);

Divider.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default Divider;
